var _metadata, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessInsightsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICOS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,64.78c-8.33,0-15.1-6.77-15.1-15.1s6.78-15.1,15.1-15.1,15.1,6.78,15.1,15.1-6.78,15.1-15.1,15.1ZM20.9,37.06c-6.96,0-12.62,5.66-12.62,12.62s5.66,12.62,12.62,12.62,12.62-5.66,12.62-12.62-5.66-12.62-12.62-12.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.1,32.2c-8.33,0-15.1-6.78-15.1-15.1s6.78-15.1,15.1-15.1,15.1,6.78,15.1,15.1-6.78,15.1-15.1,15.1ZM79.1,4.48c-6.96,0-12.62,5.66-12.62,12.62s5.66,12.62,12.62,12.62,12.62-5.66,12.62-12.62-5.66-12.62-12.62-12.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.25,98.01c-8.33,0-15.1-6.78-15.1-15.1s6.78-15.1,15.1-15.1,15.1,6.78,15.1,15.1-6.78,15.1-15.1,15.1ZM78.25,70.29c-6.96,0-12.62,5.66-12.62,12.62s5.66,12.62,12.62,12.62,12.62-5.66,12.62-12.62-5.66-12.62-12.62-12.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.9,91.19c-.69,0-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24c4.11,0,7.46-3.34,7.46-7.46,0-.69.56-1.24,1.24-1.24s1.24.56,1.24,1.24c0,5.48-4.46,9.94-9.94,9.94Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.18,58.6c-.69,0-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24c4.11,0,7.46-3.34,7.46-7.45,0-.69.56-1.24,1.24-1.24s1.24.56,1.24,1.24c0,5.48-4.46,9.94-9.94,9.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.74,26.02c-.69,0-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24c4.11,0,7.46-3.34,7.46-7.45,0-.69.56-1.24,1.24-1.24s1.24.56,1.24,1.24c0,5.48-4.46,9.94-9.94,9.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.19,38.12c-.43,0-.85-.23-1.08-.63-.34-.59-.13-1.35.46-1.7l25.18-14.39c.59-.33,1.35-.13,1.7.46.34.59.13,1.35-.46,1.7l-25.18,14.39c-.19.11-.4.16-.62.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.63,45.74c-.43,0-.85-.23-1.08-.63-.34-.6-.13-1.35.46-1.7l25.18-14.39c.59-.33,1.35-.14,1.7.46.34.6.13,1.35-.46,1.7l-25.18,14.39c-.19.11-.4.16-.62.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.16,71.3c-.2,0-.41-.05-.6-.16l-25.39-14.02c-.6-.33-.82-1.09-.49-1.69.33-.61,1.09-.82,1.69-.49l25.39,14.02c.6.33.82,1.09.49,1.69-.23.41-.65.64-1.09.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.96,79.06c-.2,0-.41-.05-.6-.16l-25.39-14.02c-.6-.33-.82-1.09-.49-1.69.33-.6,1.09-.82,1.69-.49l25.39,14.02c.6.33.82,1.09.49,1.69-.23.41-.65.64-1.09.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessInsightsIcon);
export default __webpack_public_path__ + "static/media/businessInsightsIcon.aeda1bfb8e375529a51d2b96d71de090.svg";
export { ForwardRef as ReactComponent };